// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file AirSpaceBoundary.proto (package AirSpaceBoundary, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file AirSpaceBoundary.proto.
 */
export const file_AirSpaceBoundary: GenFile = /*@__PURE__*/
  fileDesc("ChZBaXJTcGFjZUJvdW5kYXJ5LnByb3RvEhBBaXJTcGFjZUJvdW5kYXJ5It8CChBBaXJTcGFjZUJvdW5kYXJ5EjgKEmFpcnNwYWNlYm91bmRhcnlpZBgBIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRItCghjb25maWdJZBgCIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEicKAmlkGAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLQoJbWFwc3RhdHVzGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLkJvb2xWYWx1ZRIqCgRuYW1lGAUgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi4KCXByb2plY3RJZBgGIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi4KCHVuaXF1ZWlkGAcgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlQkYKLWNvbS5nbXYuZGVtZXRlci5uYXZhaWRzLm1vZGVsLnByb3RvLmdlbmVyYXRlZEIVQWlyc3BhY2VCb3VuZGFyeVByb3RvYgZwcm90bzM", [file_google_protobuf_wrappers]);

/**
 * @generated from message AirSpaceBoundary.AirSpaceBoundary
 */
export type AirSpaceBoundary = Message<"AirSpaceBoundary.AirSpaceBoundary"> & {
  /**
   * @generated from field: google.protobuf.StringValue airspaceboundaryid = 1;
   */
  airspaceboundaryid?: string;

  /**
   * @generated from field: google.protobuf.Int32Value configId = 2;
   */
  configId?: number;

  /**
   * @generated from field: google.protobuf.Int32Value id = 3;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.BoolValue mapstatus = 4;
   */
  mapstatus?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue name = 5;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.Int32Value projectId = 6;
   */
  projectId?: number;

  /**
   * @generated from field: google.protobuf.StringValue uniqueid = 7;
   */
  uniqueid?: string;
};

/**
 * Describes the message AirSpaceBoundary.AirSpaceBoundary.
 * Use `create(AirSpaceBoundarySchema)` to create a new message.
 */
export const AirSpaceBoundarySchema: GenMessage<AirSpaceBoundary> = /*@__PURE__*/
  messageDesc(file_AirSpaceBoundary, 0);

